import { BrowserModule } from '@angular/platform-browser';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { ConfigInitializer } from './services/config/config.factory';
import { HTTP_INTERCEPTORS, HttpClient, HttpClientModule } from '@angular/common/http';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { routing } from './routes';
import { AppContainer } from './containers/app.container';
import { CommonLogicModule } from '../common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppSandbox } from './app.sandbox';
import { TokenInterceptor } from './services/token.interceptor';
import { CorporateClientInterceptor } from './services/corporate-client.interceptor';
import { RouterModule } from '@angular/router';
import { CorporateClientService } from './services/corporate-client.service';
import { StoreModule } from '@ngrx/store';
import { settingsReducer } from '../statemanagement/reducers/settings.reducer';
import { userReducer } from '../statemanagement/reducers/user.reducer';
import { AppConfigService } from './services/app-config.service';
import { CommonProfileService } from './services/profile.service';
import { ListSearchModule } from '../common/components/list-search';
import { CommonServiceModule } from './services';
import { addOrderReducer } from '../statemanagement/reducers/add-order.reducer';
import { SwUpdateService } from './external-app-services/sw/sw-update.service';
import { NavMobileComponent } from './components/nav-mobile/nav-mobile.component';
import { NavDesktopComponent } from './components/nav-desktop/nav-desktop.component';
import { NavFooterComponent } from './components/nav-footer/nav-footer.component';
import { ExternalAppServices } from './external-app-services';
import { corporateClientReducer } from '../statemanagement/reducers/corporate-client.reducer';
import { overviewReducer } from '../statemanagement/reducers/overview.reducer';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { environment } from '../environments/environment';
import { ServiceWorkerModule } from '@angular/service-worker';
import { BrowserSupportedService } from './services/browser-supported.service';
import { EffectsModule } from '@ngrx/effects';

export const createTranslateLoader = (http: HttpClient) => new TranslateHttpLoader(http, '' +
    './assets/i18n/', '.json');
export const loadConfig = (appConfigService: AppConfigService) => () => appConfigService.load();

@NgModule({
    imports: [
        routing,
        HttpClientModule,
        CommonLogicModule,
        BrowserAnimationsModule,
        BrowserModule,
        RouterModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: createTranslateLoader,
                deps: [HttpClient]
            }
        }),
        StoreModule.forRoot({
            settings: settingsReducer,
            addOrder: addOrderReducer,
            user: userReducer,
            corporateClient: corporateClientReducer,
            overview: overviewReducer
        }),
        EffectsModule.forRoot(),
        ListSearchModule,
        CommonServiceModule,
        ExternalAppServices,
        StoreDevtoolsModule.instrument({
            maxAge: 25,
            logOnly: environment.production
        }),
        ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production })
    ],
    declarations: [
        AppContainer,
        NavMobileComponent,
        NavDesktopComponent,
        NavFooterComponent
    ],
    providers: [
        ConfigInitializer.init(),
        AppSandbox,
        CorporateClientService,
        CommonProfileService,
        SwUpdateService,
        BrowserSupportedService,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: TokenInterceptor,
            multi: true,
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: CorporateClientInterceptor,
            multi: true,
        },
        AppConfigService,
        {
            provide: APP_INITIALIZER,
            useFactory: loadConfig,
            deps: [AppConfigService],
            multi: true,
        }
    ],
    bootstrap: [AppContainer]
})
export class AppModule {}
